import {useMemo} from 'react';
import {useLocation} from 'react-router-dom';
import queryString from 'query-string';
import ListSelectFilter from '../../common/ListSelectFilter';
import {getSortedParams} from '../../../helpers';
import {
  INITIAL_QUERY, COMPLETED_FILTER_OPTIONS, DATE_CREATED_FILTER_OPTIONS
} from '../../../constants/surveys';

const Filters = () => {
  const {search} = useLocation();

  const query = useMemo(() => ({
    ...INITIAL_QUERY,
    ...getSortedParams(queryString.parse(search))
  }), [search]);

  return (
    <div className="list-filters">
      <p className="list-filters__title">Quick Filters:</p>
      <div className="list-filters__form-group">
        <ListSelectFilter
          name="completed"
          options={COMPLETED_FILTER_OPTIONS}
          query={query}
          label="Completed"
        />
        <ListSelectFilter
          name="date_created"
          options={DATE_CREATED_FILTER_OPTIONS}
          query={query}
          label="Date created"
        />
      </div>
    </div>
  );
};

export default Filters;
